import { getAccountInfo, checkMemberSignStatus } from '@/api/affiliate'

export default {
  state: {
    signupInfo: {
      account: {},
      web: {}
    },
    userInfo: {},
    memberSignInfo: null
  },
  mutations: {},
  actions: {
    initSignupInfo({ state }) {
      state.signupInfo = {
        account: {},
        web: {}
      }
    },
    getAccountInfo({ state }) {
      // 获取用户信息
      getAccountInfo().then(res => {
        state.userInfo = res.data?.info || {}
      })
    },
    checkSign({ state }) {
      state.memberSignInfo = null
      checkMemberSignStatus().then(res => {
        state.memberSignInfo = res.data || {}
      })
    }
  }
}
